import { render, staticRenderFns } from "./LabeledCheckbox.vue?vue&type=template&id=41886236&scoped=true"
import script from "./LabeledCheckbox.vue?vue&type=script&lang=js"
export * from "./LabeledCheckbox.vue?vue&type=script&lang=js"
import style0 from "./LabeledCheckbox.vue?vue&type=style&index=0&id=41886236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41886236",
  null
  
)

export default component.exports